import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { TaskSummary } from '@/components/features/tasks/sales_order_contract/TaskSummary';
import { TaskProgress } from '@/components/features/tasks/sales_order_contract/TaskProgress';
import { TaskFiles } from '@/components/features/tasks/sales_order_contract/TaskFiles';
import { Comments } from '@/components/features/tasks/sales_order_contract/Comments';
import { Activities } from '@/components/features/tasks/sales_order_contract/Activities';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { ToDoList } from '@/components/features/tasks/sales_order_contract/ToDoList';
import { ProjectInfo } from '@/components/features/tasks/sales_order_contract/ProjectInfo';

export const SalesOrderContractTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  useEffect(() => setTitle(`契約申請（売上）タスク詳細`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `プロジェクト（売上） - ${_t_!.name}`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders` },
        { label: `プロジェクト（売上）詳細`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}` },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row mb-4">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>
          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
